module.exports = __webpack_public_path__ + "img/tbt305-1991.prt.a10f5487.jpg";